module.exports = __webpack_public_path__ + "static/assets/a61733a2c9f1307f68ff37d651c2031d.png";